(function () {
  var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
  var cartUrl = (window.theme && theme.routes && theme.routes.cart) || '/cart';

  function updateCount() {
    fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__count').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? cart.item_count : '';
        });
      })
      .catch(function () {});
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
  }

  function notify(title) {
    var tpl = document.getElementById('AddedNotification');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    node.setAttribute('data-product-title', title || '');
    document.body.appendChild(node);
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.classList || !form.classList.contains('lb-add')) return;
    evt.preventDefault();

    var btn = form.querySelector('.lb-add__btn');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }

    var data = new FormData(form);
    data.delete('return_to');

    fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: data })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          if (btn) {
            btn.textContent = res.body.description || 'Unavailable';
            btn.disabled = false;
            setTimeout(function () { btn.textContent = label; }, 2500);
          }
          return;
        }
        updateCount();
        refreshDrawer();
        notify(res.body.product_title || res.body.title || '');
        if (btn) {
          btn.textContent = 'Added';
          btn.classList.add('lb-add__btn--added');
          setTimeout(function () {
            btn.textContent = label;
            btn.disabled = false;
            btn.classList.remove('lb-add__btn--added');
          }, 2000);
        }
      })
      .catch(function () { form.submit(); });
  });
})();
(function () {
  function watch() {
    var bar = document.querySelector('sticky-atc');
    if (!bar) return;
    function sync() {
      var showing = !bar.classList.contains('sticky-atc--out')
        && !bar.classList.contains('invisible');
      document.body.classList.toggle('lb-atc-visible', showing);
    }
    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    sync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();